import axios from 'axios'
import Swal from 'sweetalert2'
import { SESSION_NAME } from '../../v2/constant/constantApp'
import { useAuthStore } from '../../v2/stores/useAuthStore'
import { useUiStore } from '../../v2/stores/useUiStore'

const Api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
})

let isHandlingError = false
let controllers = []
let isRefreshing = false
let failedQueue = []

function processQueue(error, token = null) {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error)
    } else {
      prom.resolve(token)
    }
  })

  failedQueue = []
}

/**
 * REQUEST INTERCEPTOR
 */
Api.interceptors.request.use(
  (config) => {
    const ui = useUiStore()
    ui.startLoading()
    
    const token = localStorage.getItem(SESSION_NAME)

    if (token) {
      config.headers = config.headers || {}
      config.headers.Authorization = `${token}`
    }

    //console.log(config,'..config')

    const controller = new AbortController()
    config.signal = controller.signal
    controllers.push(controller)

    return config
  },
  (error) => {
    const ui = useUiStore()
    ui.stopLoading()
    return Promise.reject(error)
  }
)


/**
 * RESPONSE INTERCEPTOR
 */
Api.interceptors.response.use(
  (response) => {
    const ui = useUiStore()
    ui.stopLoading()
    return response
  },
  async (error) => {
    const ui = useUiStore()
    ui.stopLoading()

    const status = error.response?.status
    const message = error.response?.data?.error || error.response?.data?.message
    console.log(status,'..status')
    console.log(message, '..message')
    console.log(isHandlingError,'..isHandlingError')

    if (isHandlingError) return Promise.reject(error)

    isHandlingError = true

    // ===============================
    // NETWORK ERROR (No Response)
    // ===============================
    if (!error.response) {
      await Swal.fire({
        position: 'top',
        icon: 'error',
        title: 'Network Error',
        text: 'Tidak dapat terhubung ke server. Periksa koneksi internet Anda.',
      })

      isHandlingError = false
      return Promise.reject(error)
    }

    // ===============================
    // 401 - SESSION EXPIRED
    // ===============================
    if (status === 401 && message === 'Session expired') {
      await Swal.fire({
        position: 'top',
        icon: 'warning',
        title: 'Session Expired',
        text: 'Session anda telah habis. Silakan login kembali.',
        confirmButtonText: 'OK',
      })

      const auth = useAuthStore()
      auth.logout()

      isHandlingError = false
      return Promise.reject(error)
    }

    // ===============================
    // 400 - BAD REQUEST
    // ===============================
    if (status === 400) {
      await Swal.fire({
        position: 'top',
        icon: 'error',
        title: 'Bad Request',
        text: message || 'Permintaan tidak valid.',
      })

      isHandlingError = false
      return Promise.reject(error)
    }

    // ===============================
    // 500 - SERVER ERROR
    // ===============================
    if (status === 500) {
      await Swal.fire({
        position: 'top',
        icon: 'error',
        title: 'Server Error',
        text: 'Terjadi kesalahan pada server. Silakan coba lagi nanti.',
      })

      isHandlingError = false
      return Promise.reject(error)
    }

    isHandlingError = false
    return Promise.reject(error)
  }
)

export function cancelAllRequests() {
    controllers.forEach(c => c.abort())
    controllers = []
}

export default Api